/* ===========================================================
   Zaverni — email popup controller
   Trigger: delay (seconds) and/or scroll %; cooldown via localStorage.
   Success state: discount code reveal — shows immediately, marks cooldown,
   tap the code to copy.
   Accessibility: focus trap + ESC to close + restore focus.
   =========================================================== */
(function () {
  var popup = document.getElementById('zv-email-popup');
  if (!popup) return;

  // v2: v1 stored a rolling 30-day expiry, so old records must not suppress the
  // new "next calendar day" behaviour.
  var COOLDOWN_KEY = 'zaverni_popup_seen_v2';
  var delay = parseInt(popup.getAttribute('data-delay') || '0', 10);
  var scrollPct = parseInt(popup.getAttribute('data-scroll') || '0', 10);
  var cooldownDays = parseInt(popup.getAttribute('data-cooldown') || '30', 10);

  var emailInput = popup.querySelector('input[type="email"]');
  var codeChip = popup.querySelector('[data-zv-code]');
  var lastFocused = null;
  var shown = false;

  function isDismissed() {
    try {
      var seen = parseInt(localStorage.getItem(COOLDOWN_KEY) || '0', 10);
      return seen > 0 && Date.now() < seen;
    } catch (e) {
      return false;
    }
  }

  /**
   * Expiry is padded to local midnight: dismissing today with a 1-day cooldown
   * shows the popup again right after midnight tomorrow (not a rolling 24h).
   */
  function rememberFor(days) {
    try {
      var d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() + days);
      localStorage.setItem(COOLDOWN_KEY, String(d.getTime()));
    } catch (e) { /* private mode — ignore */ }
  }

  function remember() {
    rememberFor(cooldownDays);
  }

  function show(force) {
    if (shown) return;
    if (!force && isDismissed()) return;
    shown = true;
    lastFocused = document.activeElement;
    popup.hidden = false;
    // next frame so the transition runs from the hidden/initial state
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
        if (codeChip) {
          codeChip.focus();
        } else if (emailInput) {
          emailInput.focus();
        }
      });
    });
  }

  function hide() {
    if (!shown) return;
    popup.classList.remove('is-open');
    setTimeout(function () {
      popup.hidden = true;
    }, 350);
    remember();
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onKeydown(e) {
    if (popup.hidden) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      hide();
      return;
    }
    if (e.key === 'Tab') {
      // minimal focus trap within the stage
      var focusables = popup.querySelectorAll(
        'button, input, a[href], [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // close on overlay / close button — delegated, because both the overlay and the
  // button carry [data-zv-popup-close] and querySelector would only bind the first.
  popup.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-zv-popup-close]');
    if (trigger) {
      e.preventDefault();
      hide();
    }
  });
  document.addEventListener('keydown', onKeydown);

  // discount code: tap to copy
  if (codeChip) {
    codeChip.addEventListener('click', function () {
      var code = codeChip.textContent.trim();
      var hint = popup.querySelector('.zv-popup-code-hint');
      function confirmCopy() {
        if (hint) {
          hint.textContent = 'Copied — apply it at checkout.';
          setTimeout(function () { hint.textContent = codeChip.getAttribute('data-hint') || 'Tap to copy — apply it at checkout.'; }, 2400);
        }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(confirmCopy, function () {});
      } else {
        // fallback: legacy execCommand
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); confirmCopy(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  }

  // ---- success state: Shopify re-rendered the page after subscribe ----
  if (codeChip) {
    // persist the hint text before any copy feedback overwrites it
    var hintEl = popup.querySelector('.zv-popup-code-hint');
    if (hintEl) codeChip.setAttribute('data-hint', hintEl.textContent);
    // already subscribed: show the code once, then stay quiet for a year
    rememberFor(365);
    show(true);
    return;
  }

  // ---- triggers (fresh visit) ----
  function scheduleShow() {
    if (isDismissed()) return;

    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      show(false);
    }

    // delay trigger
    if (delay > 0) {
      setTimeout(fire, delay * 1000);
    }

    // scroll trigger (fires first, at % of page)
    if (scrollPct > 0) {
      var onScroll = function () {
        var h = document.documentElement;
        var max = h.scrollHeight - h.clientHeight;
        if (max <= 0) return;
        var pct = (h.scrollTop / max) * 100;
        if (pct >= scrollPct) {
          fire();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // no trigger configured → show immediately after a tick
    if (delay === 0 && scrollPct === 0) {
      fire();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleShow);
  } else {
    scheduleShow();
  }
})();
